import React, { useContext, useCallback } from "react";
import clsx from "clsx";
import { Form, Col, Row } from "react-bootstrap";

import { RequiredMark, Skeleton } from "components";
import { ApplicationEntryProgressContext } from "components/contexts";

import SelectAsync from "./selectAsync";
import { selectStyles } from "./selectStyles";

import stylesWithRow from "./selectAsync.module.scss";

const DropdownIndicator = () => (
	<span className="dropdownToggle" style={{ marginRight: "7px" }} />
);

// On Review
// That component is currently specific for MCC Code section
// because it spreads input and has workarounds that are needed for compatitiblity with redux forms
const SelectAsyncForMccCodeSection = ({
	input,
	meta: { touched, error },
	disabled,
	onChangeAlias,
	onBlurAlias,
	valueAlias,
	blurLoading,
	label,
	wrapperClassName,
	wrapperCustomInput,
	labelClassName,
	showRequiredMark,
	smLabel = 6,
	smSelect = 6,
	...props
}) => {
	const styles = props.styles || selectStyles;
	const showError = touched && !disabled && !blurLoading && error;
	const { triggerSave } = useContext(ApplicationEntryProgressContext);

	const handleBlur = () => {
		input.onBlur(input.value);
		triggerSave?.();
	};

	const errorText = showError && (
		<p style={selectStyles.selectAsyncErrorMessage()}>{error}</p>
	);

	const defaultControlState = {
		outlineColor: "rgba(255, 255, 255, 0.15)",
		background: "inherit",
		boxShadow: 0,
		borderRadius: 0,
		borderColor: "#7a7a7a",
		"&:hover": {
			borderColor: "#7a7a7a",
		},
	};

	let control;

	if (errorText) {
		// Override default styles to display different border
		// Making it that way as can't pass child class to component
		control = provided => ({
			...provided,
			...defaultControlState,
			borderColor: "#ba4545",
		});
	} else {
		control = provided => ({
			...provided,
			...defaultControlState,
		});
	}

	const labelBlock = label && (
		<Form.Label
			className={`${styles.wrappLabel} ${labelClassName}`}
			column
			sm={smLabel}
		>
			{label}
			{showRequiredMark && <RequiredMark />}
		</Form.Label>
	);

	const selectField = (
		<>
			<SelectAsync
				{...input}
				{...props}
				styles={{ ...styles, control }}
				components={{ DropdownIndicator }}
				onChange={onChangeAlias}
				onBlur={onBlurAlias || handleBlur}
				value={valueAlias}
				isDisabled={disabled}
			/>
			{errorText}
		</>
	);

	const SelectedWithLoader = useCallback(
		({ selectField }) => (blurLoading ? <Skeleton /> : selectField),

		[blurLoading],
	);

	return (
		<>
			{label ? (
				<div
					className={clsx(
						stylesWithRow.formGroup,
						wrapperCustomInput,
					)}
				>
					<Form.Group
						as={Row}
						className={clsx(
							stylesWithRow.inputWrapper,
							wrapperClassName,
						)}
					>
						{labelBlock}
						<Col sm={smSelect}>
							{<SelectedWithLoader selectField={selectField} />}
						</Col>
					</Form.Group>{" "}
				</div>
			) : (
				<SelectedWithLoader selectField={selectField} />
			)}
		</>
	);
};

export { SelectAsyncForMccCodeSection };
